module.exports = __webpack_public_path__ + "static/media/ticket.d8216899.svg";